import { Ai } from './Ai';
import { ArrowLeft } from './ArrowLeft';
import { ArrowRight } from './ArrowRight';
import { ArrowUp } from './ArrowUp';
import { Aspect } from './Aspect';
import { AzureLogo } from './AzureLogo';
import { Book } from './Book';
import { Bookmark } from './Bookmark';
import { Building } from './Building';
import { Calendar } from './Calendar';
import { Chart } from './Chart';
import { Check } from './Check';
import { CheckColored } from './CheckColored';
import { ChevronDown } from './ChevronDown';
import { ChevronLeft } from './ChevronLeft';
import { ChevronRight } from './ChevronRight';
import { ChevronsLeft } from './ChevronsLeft';
import { ChevronsRight } from './ChevronsRight';
import { Clock } from './Clock';
import { Close } from './Close';
import { Company } from './Company';
import { ControlCamera } from './ControlCamera';
import { ControlClose } from './ControlClose';
import { ControlMicrophone } from './ControlMicrophone';
import { Copy } from './Copy';
import { Credit } from './Credit';
import { CreditCard } from './CreditCard';
import { Dashboard } from './Dashboard';
import { Departments } from './Departments';
import { DocsRar } from './DocsRar';
import { Document } from './Document';
import { DocumentPlus } from './DocumentPlus';
import { Download } from './Download';
import { Edit } from './Edit';
import { EmptyBookmark } from './EmptyBookmark';
import { EmptyPlay } from './EmptyPlay';
import { EmptyStar } from './EmptyStar';
import { ExternalLink } from './ExternalLink';
import { EyeOff } from './EyeOff';
import { EyeOn } from './EyeOn';
import { File } from './File';
import { Filter } from './Filter';
import { Folder } from './Folder';
import { Hamburger } from './Hamburger';
import { Help } from './Help';
import { Home } from './Home';
import { Info } from './Info';
import { LaptopMinimal } from './LaptopMinimal';
import { LightBulb } from './LightBulb';
import { Like } from './Like';
import { LikeEmpty } from './LikeEmpty';
import { Logout } from './Logout';
import { MongoDBLogo } from './MongoDBLogo';
import { Moon } from './Moon';
import { Notification } from './Notification';
import { OfficeLogo } from './OfficeLogo';
import { Pause } from './Pause';
import { Pdf } from './Pdf';
import { Play } from './Play';
import { Refresh } from './Refresh';
import { Rocket } from './Rocket';
import { ScanMode } from './ScanMode';
import { Search } from './Search';
import { Send } from './Send';
import { Settings } from './Settings';
import { ShieldCheck } from './ShieldCheck';
import { SortBy } from './SortBy';
import { Star } from './Star';
import { Sun } from './Sun';
import { Survey } from './Survey';
import { Team } from './Team';
import { TextDoc } from './TextDoc';
import { Trash } from './Trash';
import { TriangleAlert } from './TriangleAlert';
import { User } from './User';
import { UserPlus } from './UserPlus';
import { Users } from './Users';
import { Wallet } from './Wallet';
import { World } from './World';
import { Xlxs } from './Xlsx';
import { Zip } from './Zip';
import { ZoomIn } from './ZoomIn';
import { ZoomOut } from './ZoomOut';

export const svg = {
  survey: Survey,
  controlMicrophone: ControlMicrophone,
  controlCamera: ControlCamera,
  controlClose: ControlClose,
  clock: Clock,
  credit: Credit,
  ai: Ai,
  chart: Chart,
  calendar: Calendar,
  rocket: Rocket,
  send: Send,
  building: Building,
  creditCard: CreditCard,
  settings: Settings,
  docsRar: DocsRar,
  aspect: Aspect,
  team: Team,
  users: Users,
  documentPlus: DocumentPlus,
  arrowDown: ChevronDown, // used in platform-ui
  arrowUp: ArrowUp,
  arrowRight: ArrowRight,
  arrowLeft: ArrowLeft,
  download: Download,
  down: ChevronDown,
  chevronDown: ChevronDown,
  chevronRight: ChevronRight,
  chevronLeft: ChevronLeft,
  chevronsRight: ChevronsRight,
  chevronsLeft: ChevronsLeft,
  book: Book,
  info: Info,
  logout: Logout,
  home: Home,
  tickets: TriangleAlert,
  warning: TriangleAlert,
  azure: AzureLogo,
  microsoft: OfficeLogo,
  organization: ShieldCheck,
  refresh: Refresh,
  check: Check,
  checkColored: CheckColored,
  close: Close,
  cross: Close,
  filter: Filter,
  dashboard: Dashboard,
  star: Star,
  emptyStar: EmptyStar,
  eyeOff: EyeOff,
  eyeOn: EyeOn,
  back: ArrowLeft,
  notification: Notification,
  lightBulb: LightBulb,
  externalLink: ExternalLink,
  copy: Copy,
  help: Help,
  search: Search,
  edit: Edit,
  scanMode: ScanMode,
  user: User,
  userPlus: UserPlus,
  mongo: MongoDBLogo,
  textDoc: TextDoc,
  pdf: Pdf,
  csv: Xlxs,
  zip: Zip,
  folder: Folder,
  file: File,
  company: Company,
  wallet: Wallet,
  document: Document,
  laptopMinimal: LaptopMinimal,
  trash: Trash,
  world: World,
  like: Like,
  departments: Departments,
  emptyPlay: EmptyPlay,
  play: Play,
  pause: Pause,
  likeEmpty: LikeEmpty,
  hamburger: Hamburger,
  sortBy: SortBy,
  bookmark: Bookmark,
  emptyBookmark: EmptyBookmark,
  zoomIn: ZoomIn,
  zoomOut: ZoomOut,
  moon: Moon,
  sun: Sun,
};
